<template>
  <teleport to="body">
    <transition name="fade">
      <div
        v-if="show"
        :class="[
          'fixed z-[9999] top-20 left-1/2 -translate-x-1/2 px-6 py-4 rounded shadow-lg flex items-start space-x-3 pointer-events-auto',
          typeClass
        ]"
        style="min-width:300px; max-width:600px;"
        role="alert"
      >
        <span v-if="icon" class="text-xl">{{ icon }}</span>
        <span class="text-base font-medium whitespace-pre-line">{{ message }}</span>
        <button class="ml-4 text-lg font-bold focus:outline-none" @click="close">&times;</button>
      </div>
    </transition>
  </teleport>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  message: { type: String, default: '' },
  type: { type: String, default: 'success' }, // 'success', 'error', 'warning'
  duration: { type: Number, default: 3500 }
});

const emit = defineEmits(['update:show']);

const typeClass = computed(() => {
  switch (props.type) {
    case 'error':
      return 'bg-red-100 text-red-800 border border-red-300';
    case 'warning':
      return 'bg-yellow-100 text-yellow-800 border border-yellow-300';
    case 'success':
    default:
      return 'bg-green-100 text-green-800 border border-green-300';
  }
});

const icon = computed(() => {
  switch (props.type) {
    case 'error':
      return '⛔';
    case 'warning':
      return '⚠️';
    case 'success':
    default:
      return '✅';
  }
});

const show = ref(props.show);

watch(() => props.show, (val) => {
  show.value = val;
  if (val && props.duration > 0 && props.type !== 'error') {
    setTimeout(() => close(), props.duration);
  }
});

function close() {
  show.value = false;
  emit('update:show', false);
}

onMounted(() => {
  if (show.value && props.duration > 0 && props.type !== 'error') {
    setTimeout(() => close(), props.duration);
  }
});
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
